import { fileDownload } from 'fetcher';
import { downloadBlob } from 'utils';

// Medya türü/alan etiketleri ve küçük-resim çözümü tek kaynaktan gelir.
export {
  MEDIA_TYPE_LABELS,
  MEDIA_OFFER_FIELD_LABELS,
  formatMediaOfferFieldValue,
  getMediaTypeIcon,
  isPreviewableMedia,
  resolvePosterUrl,
} from 'components/SendItems/AddMediaContent/helpers';

export const handleBlobDownload = async (fileUrl, fileName) => {
  const { data } = await fileDownload(fileUrl);
  downloadBlob(data, fileName);
};
